<template>
  <b-container class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>Trhové ceny - OKTE (Celkové výsledky DT)</h2>
      </div>
      <div class="form-inline">
        <label class="mr-1">Dátum:</label>
        <single-date-picker
          :value="date"
          :disabled-dates="{
            from: $moment().add(1, 'day').toDate(),
          }"
          @input="changeDate"
        />
      </div>
      <b-dropdown
        v-b-tooltip.hover.bottom
        class="ml-1"
        menu-class="min-w15 dropdown-menu-animated"
        variant="secondary"
      >
        <template #button-content>
          <b-icon icon="file-earmark-spreadsheet" class="mr-1" />
          Exportovať
        </template>
        <b-dropdown-form>
          <div class="d-flex align-items-center">
            <date-picker
              v-model="exportDate"
              class="daterange-sm"
              style="width: 200px"
              opens="left"
              :append-to-body="false"
              :ranges="false"
            />
            <b-btn variant="primary" @click="exportData"> Exportovať</b-btn>
          </div>
        </b-dropdown-form>
      </b-dropdown>
    </div>
    <div class="h-100" style="min-height: 1px">
      <b-overlay class="h-100" :show="loading" :blur="null" opacity="0">
        <transition name="fadeDownShort" mode="out-in">
          <div v-if="!loading" v-bar class="bar-out">
            <div>
              <b-alert :show="!data?.length" variant="danger"
                >Neboli nájdené žiadne dáta
              </b-alert>
              <b-row v-if="data?.length" class="my-2">
                <b-col md="8">
                  <Chart :data="chartData" />
                </b-col>
                <b-col md="4">
                  <client-table
                    table-class="table-sm"
                    :data="data"
                    :columns="table.columns"
                    :sort-by.sync="table.sortBy"
                    :searchable="false"
                    striped
                  >
                    <template #cell(period)="data">
                      <div class="font-weight-bold fs-lg">
                        {{ data.item.period }}
                      </div>
                      {{ getTimeInterval(data.item.period) }}
                    </template>
                  </client-table>
                </b-col>
              </b-row>
            </div>
          </div>
        </transition>
      </b-overlay>
    </div>
  </b-container>
</template>
<script>
import moment from 'moment'
import energyMarketService from '@/services/api/energyMarketService.js'
import Chart from './Chart.vue'
import SingleDatePicker from '@/components/inputs/SingleDatePicker'
import ClientTable from '@/components/ClientTable'
import DatePicker from '@/components/inputs/DatePicker'
import { map } from 'lodash'

export default {
  components: { Chart, SingleDatePicker, ClientTable, DatePicker },
  data() {
    return {
      loading: false,
      data: [],
      date: moment().format('YYYY-MM-DD'),
      exportDate: {
        ge: moment().startOf('month').format('YYYY-MM-DD'),
        lt: moment().format('YYYY-MM-DD'),
      },
      table: {
        columns: [
          {
            key: 'period',
            label: 'Perióda',
            class: 'text-center',
            sortable: true,
          },
          {
            key: 'price',
            label: 'Cena (€ bez dph/MWh)',
            class: 'text-right',
            tdClass: 'align-middle text-nowrap',
            formatter: (value) =>
              value !== null
                ? this.$options.filters.formatNumber(value, 2)
                : '-',
            sortable: true,
          },
        ],
        sortBy: 'period',
      },
    }
  },
  computed: {
    chartData() {
      return map(this.data, (i) => {
        return {
          x: i.period,
          y: i.price,
        }
      })
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    getTimeInterval(period) {
      const totalData = this.data.length
      if (totalData === 96) {
        // 15-minute intervals
        const totalMinutes = (period - 1) * 15
        const startHour = Math.floor(totalMinutes / 60)
        const startMin = totalMinutes % 60
        const endTotalMinutes = period * 15
        const endHour = Math.floor(endTotalMinutes / 60)
        const endMin = endTotalMinutes % 60
        const formatTime = (h, m) =>
          `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`
        return `${formatTime(startHour, startMin)} - ${formatTime(endHour, endMin)}`
      } else if (totalData === 24) {
        // hourly intervals
        const startHour = period - 1
        const endHour = period
        return `${startHour.toString().padStart(2, '0')}:00 - ${endHour.toString().padStart(2, '0')}:00`
      } else {
        return period.toString()
      }
    },
    changeDate(date) {
      this.date = date
      this.fetchData()
    },
    fetchData(silent = false) {
      this.loading = !silent
      energyMarketService
        .getOkteData({
          date: { ge: this.date, le: this.date },
        })
        .then((res) => {
          this.data = res.data[0]?.data
          if (!silent) {
            this.loading = false
          }
        })
        .catch(() => {
          this.$swal({
            type: 'error',
            position: 'top',
            showCloseButton: true,
            text: 'Vyskytla sa chyba',
            timer: 5000,
          })
        })
    },
    exportData() {
      energyMarketService
        .downloadOkteExport({
          dateFrom: this.exportDate.ge,
          dateTo: this.exportDate.lt,
        })
        .then((res) => {
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
  },
}
</script>
